import { Box, Flex } from "@/components/layout/flexbox";
import StartsSvg from "@/components/pieces/roleplays/svg/StartsSvg";
import { LIGHT_STEEL_GRAY } from "@/css/constants";
import { RoleplaySessionCommentFragment } from "@/graphql";

interface RoleplaySessionCommentProps {
  comment: RoleplaySessionCommentFragment;
}

export function RoleplaySessionComment({
  comment,
}: RoleplaySessionCommentProps) {
  const { id, text, user } = comment;

  if (user === "AI") {
    return (
      <Flex key={`comment-${id}`} p={2}>
        <Flex mr={2} minWidth="25px" height="25px">
          <StartsSvg width={25} height={25} />
        </Flex>

        <Box
          p={2}
          backgroundColor={LIGHT_STEEL_GRAY}
          fontSize="14px"
          fontWeight={400}
          className="round-corners"
        >
          {text}
        </Box>
      </Flex>
    );
  }

  return (
    <Flex
      key={`comment-${id}`}
      p={2}
      alignSelf={user === "user" ? "flex-end" : "flex-start"}
      maxWidth="80%"
    >
      <Flex mr={2} minWidth="25px" height="25px">
        <StartsSvg width={25} height={25} />
      </Flex>

      <Box
        p={2}
        backgroundColor={LIGHT_STEEL_GRAY}
        fontSize="14px"
        fontWeight={400}
        className="round-corners"
      >
        {text}
      </Box>
    </Flex>
  );
}
